var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKreisToolAktiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Kreis-Tool-Aktiv__Icn/40px/Kreis-Tool-Aktiv",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Kreis-Tool-Aktiv__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Kreis-Tool-Aktiv__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.0002857,13 L20.998,19.999 L28,20 L28,26 L20.998,25.999 L21.0002857,33 L15.0002857,33 L14.999,25.999 L8,26 L8,20 L14.999,19.999 L15.0002857,13 L21.0002857,13 Z M19,15 L17,15 L16.999,22 L10,22 L10,24 L16.999,24 L17,31 L19,31 L18.999,24 L26,24 L26,22 L18.999,22 L19,15 Z M29,5 C32.8659932,5 36,8.13400675 36,12 C36,15.8659932 32.8659932,19 29,19 C25.1340068,19 22,15.8659932 22,12 C22,8.13400675 25.1340068,5 29,5 Z M29,7 C26.2385763,7 24,9.23857625 24,12 C24,14.7614237 26.2385763,17 29,17 C31.7614237,17 34,14.7614237 34,12 C34,9.23857625 31.7614237,7 29,7 Z M29,8 C31.209139,8 33,9.790861 33,12 C33,14.209139 31.209139,16 29,16 C26.790861,16 25,14.209139 25,12 C25,9.790861 26.790861,8 29,8 Z M29,10 C27.8954305,10 27,10.8954305 27,12 C27,13.1045695 27.8954305,14 29,14 C30.1045695,14 31,13.1045695 31,12 C31,10.8954305 30.1045695,10 29,10 Z",
    id: ".._.._src_svg_Icn_40px_Kreis-Tool-Aktiv__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKreisToolAktiv);
export default __webpack_public_path__ + "static/media/Kreis-Tool-Aktiv.02302b40f181dd29c6ee343ca826240e.svg";
export { ForwardRef as ReactComponent };